var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:{grey: _vm.grey, large: _vm.large, outline: _vm.outline},style:({fontSize: _vm.fontSize ? _vm.fontSize + 'px' : ''})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }